import {
    Chart,
    LineElement,
    PointElement,
    LineController,
    BarElement,
    BarController,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend,
    ChartData,
    TooltipItem,
    Point
} from 'chart.js';

// Register the required components
Chart.register(
    LineElement,
    PointElement,
    LineController,
    BarElement,
    BarController,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend
);

// Re-export types
export type { ChartData, TooltipItem, Point };

export default Chart; 